import { render, staticRenderFns } from "./VacanciesReport.vue?vue&type=template&id=234ede90&scoped=true&"
import script from "./VacanciesReport.vue?vue&type=script&lang=js&"
export * from "./VacanciesReport.vue?vue&type=script&lang=js&"
import style0 from "./VacanciesReport.vue?vue&type=style&index=0&id=234ede90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234ede90",
  null
  
)

export default component.exports